import { render } from "./ThePurchaseAuthorizationList.vue?vue&type=template&id=2f54a862&scoped=true&ts=true"
import script from "./ThePurchaseAuthorizationList.vue?vue&type=script&lang=ts"
export * from "./ThePurchaseAuthorizationList.vue?vue&type=script&lang=ts"

import "./ThePurchaseAuthorizationList.vue?vue&type=style&index=0&id=2f54a862&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f54a862"]])

export default __exports__